import position from '../img/icon-position.png'
import mobile from '../img/icon-mobile.png'
import mail from '../img/icon-mail.png'


const MapFooter = [
{
img: position,
alt: 'indirizzo',
testo: 'Via G. Puccini, 94 - Perugia',
href: 'https://maps.app.goo.gl/Zz1NtXpJdtGTyvzGA',
},
{
img: mobile,
alt: 'cellulare',
testo: '379 143 1147',
href: 'tel:+393791431147',

},
{
img: mail,
alt:'email',
testo: 'giralda.design@gmail.com',
href: 'mailto:giralda.design@gmail.com',

}
]


const Footer = () => {
return(
<footer className="container-fluid bg-light d-flex flex-column flex-lg-row justify-content-center p-3 shadow">
{ MapFooter.map( dato => 
<div className={`d-flex justify-content-center align-items-center flex-wrap text-center ${dato.alt !== 'email' ? 'pb-4 pb-lg-0' : 'pb-0'} mb-lg-0`}>
<div className='pe-2'>
<img style={{'width': '20px'}} src={dato.img} alt={dato.alt}></img></div>
<a href={dato.href} target='_blank' rel="noreferrer" className={dato.alt !== 'email' ? 'pe-0 pe-lg-5' : '' }
>{dato.testo}</a>
</div>
)}

</footer>
)};

export default Footer;